import type {
  TFaixaInvestimento,
  TGetEmpreendimentosFilters,
} from '@/features/empreendimentos/shared/types/empreendimento'
import type { TTipoEmpreendimento } from '@/types/empreendimento'
import type { TTipoProdutoPrecificadoBrasilEnum } from '@/types/produto'

export const empreendimentosKeys = {
  empreendimentos: ['empreendimentos'] as const,
  lista: <TFaixa = TFaixaInvestimento>(filtros: TGetEmpreendimentosFilters<TFaixa>) =>
    [...empreendimentosKeys.empreendimentos, 'lista', filtros] as const,
  novaSimulacaoEmpreendimento: (
    tipoDeEmpreendimento: TTipoEmpreendimento,
    tipoDoProduto: TTipoProdutoPrecificadoBrasilEnum,
    idsExternosExcluidos: string[],
  ) =>
    [
      ...empreendimentosKeys.empreendimentos,
      'nova-simulacao-empreendimento',
      tipoDeEmpreendimento,
      tipoDoProduto,
      idsExternosExcluidos,
    ] as const,
  disponiveis: (apenasFuturo?: boolean) =>
    [...empreendimentosKeys.empreendimentos, 'disponiveis', ...(apenasFuturo ? ['futuro'] : [])] as const,
  detalhes: (idExterno: number) => [...empreendimentosKeys.empreendimentos, 'detalhes', idExterno] as const,
  folders: (idExterno: number) => [...empreendimentosKeys.empreendimentos, 'folders', idExterno] as const,
  plantaDoLoteamento: (idExterno: string) =>
    [...empreendimentosKeys.empreendimentos, 'planta-do-loteamento', idExterno] as const,
  horizontais: (idRegional: string) => [...empreendimentosKeys.empreendimentos, 'horizontais', idRegional] as const,
}
